import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=248bc6a2&scoped=true&"
import script from "./contactus.vue?vue&type=script&lang=js&"
export * from "./contactus.vue?vue&type=script&lang=js&"
import style0 from "./contactus.vue?vue&type=style&index=0&id=248bc6a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248bc6a2",
  null
  
)

export default component.exports